/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Section_Workflow_TitleInputs */

const en_ticket_section_workflow_title = /** @type {(inputs: Ticket_Section_Workflow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow`)
};

const ja_ticket_section_workflow_title = /** @type {(inputs: Ticket_Section_Workflow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ワークフロー`)
};

const fr_ticket_section_workflow_title = /** @type {(inputs: Ticket_Section_Workflow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux de travail`)
};

const de_ticket_section_workflow_title = /** @type {(inputs: Ticket_Section_Workflow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsablauf`)
};

/**
* | output |
* | --- |
* | "Workflow" |
*
* @param {Ticket_Section_Workflow_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_section_workflow_title = /** @type {((inputs?: Ticket_Section_Workflow_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Section_Workflow_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_section_workflow_title(inputs)
	if (locale === "ja") return ja_ticket_section_workflow_title(inputs)
	if (locale === "fr") return fr_ticket_section_workflow_title(inputs)
	return de_ticket_section_workflow_title(inputs)
});